import { useMutation, useQuery } from '@tanstack/react-query';
import apiClient from '@shared/lib/apiClient';
import { useActiveOrganization } from '@shared/context/ActiveOrganizationContext';
/**
 * Grupos de transações ainda em "Sem categoria", agrupados por descrição
 * normalizada + direção. Com `accountId`, filtra pela conta; com `includeAll`
 * (modo geral, sem conta selecionada), lista todas as contas da org.
 */
export const useUncategorizedGroups = (accountId, options) => {
    const includeAll = options?.includeAll ?? false;
    const { activeOrganizationId, isLoadingOrganizations } = useActiveOrganization();
    const orgQueryReady = Boolean(activeOrganizationId) && !isLoadingOrganizations;
    return useQuery({
        queryKey: ['uncategorized', activeOrganizationId, accountId ?? '__all__'],
        enabled: orgQueryReady && (Boolean(accountId) || includeAll),
        queryFn: async () => {
            const { data } = await apiClient.get('/transactions/uncategorized', {
                params: accountId ? { accountId } : {},
            });
            return data;
        },
    });
};
/** Chave de query usada acima — útil para invalidar após categorizar. */
export const uncategorizedQueryKey = (organizationId, accountId) => ['uncategorized', organizationId, accountId ?? '__all__'];
export const useBulkCategorize = () => useMutation({
    mutationFn: async (dto) => {
        const { data } = await apiClient.post('/transactions/bulk-categorize', dto);
        return data;
    },
});
